import { gql } from '@apollo/client';

export const getCheckoutHealthOfferWSPayPaymentDetails = gql`query wsPayPaymentDetails(
  $offerId: String!
  $paymentOption: HealthOfferPaymentOptionEnum!
  $paymentType: String!
  $installments: Int!
) {
  health {
    checkoutHealthOfferWSPayPaymentDetails(
      offerId: $offerId
      paymentType: $paymentType
      paymentOption: $paymentOption
      installments: $installments
    ) {
      ShopID
      ShoppingCartID
      TotalAmount
      Signature
      ReturnURL
      CancelURL
      ReturnErrorURL
      PaymentPlan
      CustomerFirstName
      CustomerLastName
      CustomerAddress
      CustomerAddress
      CustomerCity
      CustomerZIP
      CustomerCountry
      CustomerPhone
      CustomerEmail
      PaymentMethod
      Iframe
      IframeResponseTarget
    }
  }
}`